'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useAnchorBarIsPinned, useAnchorBarScroll } from './anchor-bar.hooks.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const AnchorBar = renderWithRef('AnchorBar', null, (i, u)=>{
    useComponentStylesLoaded('AnchorBar', SWAN_STYLE_KEY_MAP.anchorBar);
    let { children: b, sticky: f = false, onActiveAnchorChanged: y } = i, m = _object_without_properties(i, [
        "children",
        "sticky",
        "onActiveAnchorChanged"
    ]), d = useRef(null), [O] = useAnchorBarIsPinned(d, null != f && f);
    useAnchorBarScroll(d, {
        sticky: null != f && f,
        pinned: O,
        setActiveAnchor: useCallback((e)=>{
            y && y(e);
        }, [
            y
        ])
    });
    let h = new Set([
        'swan-anchor-bar'
    ]);
    f && h.add('swan-anchor-bar-sticky'), O && h.add('swan-anchor-bar-sticky-pinned');
    let j = assignRefs(u, d);
    return useEffect(()=>{
        if (!d.current) return;
        let e = '--swan-internal-anchor-bar-el-height';
        if (O) {
            let r = d.current.offsetHeight;
            document.documentElement.style.setProperty(e, `${r}px`);
        } else document.documentElement.style.removeProperty(e);
    }, [
        O
    ]), jsx(RenderComp, {
        root: "div",
        forwardedRef: j,
        classNames: h,
        props: _object_spread_props(_object_spread({}, m), {
            darkMode: i.darkMode,
            role: 'navigation'
        }),
        children: b
    });
});

export { AnchorBar };
